var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33579 7.08579L3.66421 1.41421C2.40428 0.154284 0.25 1.04662 0.25 2.82843V14.1716C0.25 15.9534 2.40428 16.8457 3.66421 15.5858L9.33579 9.91421C10.1168 9.13317 10.1168 7.86683 9.33579 7.08579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartButton);
export default __webpack_public_path__ + "static/media/startButton.0cc0ba97eb3b214a1e12f53f85eb0be9.svg";
export { ForwardRef as ReactComponent };